<template>
	<div class="slider-off" :class = "{'noBottom':currentPart == 0}">
		<div id="slider">
		<swiper :options = "swiperOption" class ="swiper-container"  ref="mySwiper">
			<swiper-slide v-for ="(sliderList,index) in sliderLists" :key ="index" class = "slider-item"   :class ="{'slider-item-active':index == currentPart}"  @click.native = "changePart(index)">
			<a :href="'#anchor-'+index" class = "anchor" :class ="{'anchor-active':index == currentPart}">{{sliderList.title}}</a>
		</swiper-slide>
		</swiper>
	</div>
	<div class="slider-right" id = "slider-right" @click = "showAllPart">
		<div class="slider-triangle-down" ></div>
	</div>
</div>
</template>
<script>
import {swiper, swiperSlider} from 'vue-awesome-swiper';
import {mapState} from 'vuex';

export default {
	components: {
		swiper,
		swiperSlider
	},
	computed: {
		...mapState([
			'currentPart',
			'isShowAllPart',
			'sliderLists', //循环的slider数据
			'currentScrollTop'
		])
	},
	data() {
		return {
			mySwiper: null,
			sliderItems: [], //顶部滑块dom
			swiperOption: {
				notNextTick: true,
				slidesPerView: 3.8,
				freeMode: true,
				slidesOffsetBefore: 14,
				direction: 'horizontal',
				speed: 300,
				setWrapperSize: true
			}
		};
	},
	methods: {
	//修改当前展示part
		changePart(index) {
			this.$store.commit({
				type: 'CHANGE_CURRENTPART',
				currentPart: index
			});
			window.clickLog && window.clickLog('from=m_aggregation_guideclick');
		},
		showAllPart() {
			//记录当前滚动条高度，
			//当用户没有重新选择新的模块而是直接点击右上角收起展开项时应回到之前的滚动高度
			this.$store.commit({
				type: 'CURRENTSCROLLTOP',
				currentScrollTop: document.body.scrollTop
			});
			//顶部展示全部选项的时候禁止页面滚动
			document.getElementById('app').className = 'forbidscroll';
			this.$store.commit({type: 'IS_SHOW_ALL_PART', state: !this.isShowAllPart});
			window.clickLog && window.clickLog('from=m_aggregation_guidemore');
		}
	},
	watch: {
		currentPart: function(val) {
			if (val > 0) {
				this.$refs.mySwiper.swiper.slideTo(val - 1, 300, false);
			} else {
				this.$refs.mySwiper.swiper.slideTo(val, 300, false);
			}
		}
	}
};
</script>
<style lang = "scss">
@import '../../assets/style/public.scss';
.noBottom{
	border-bottom: 0 !important;
}
.slider-off {
	width:100%;
	height:px2rem(88px);
	border-bottom: 1px solid #EAEAEA;
	.swiper-container{
		height:100%;
	}
	#slider{
	white-space: nowrap;
	display: inline-block;
	position: absolute;
	overflow: hidden;
	font-size: 0;
	height:100%;
	width:90%;
	.slider-item {
		display: inline-block;
		vertical-align: top;
		font-size: $font-size;
		color: #333;
		height: $height;
		line-height: $height;
		text-align: center;
		background: $white;
	}
	.slider-item-active {
		position: relative;
		color: #FF552E;
	}
	.anchor-active{
		position: relative;
		&:before {
			content: "\e903";
			font-family: "iconfont" !important;
			display: inline-block;
			position: absolute;
			left: px2rem(-35px);
			padding-top:px2rem(26px);
			/* top:px2rem(-2px); */
			width: px2rem(28px);
			height: px2rem(28px);
			line-height: px2rem(28px);
			font-style: normal;
			font-weight: normal;
			font-size: $font-size;
		};
	}
}
.slider-right {

	@extend .slider-right-common;
	.slider-triangle-down {
		position: relative;
		width: 100%;
		height: 100%;
		&:before{
			@extend .slider-triangle-common;
			content: '\e901';
			color: #ccc;
		}
	}
}
}
</style>


// WEBPACK FOOTER //
// sliderOff.vue?a48c45f0